export default "__VITE_ASSET__Cxh2zQ8S__"